
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/en/claims",
      function () {
        return require("private-next-pages/nl/en/claims.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/en/claims"])
      });
    }
  